// in ./CustomResetViewsButton.js
import React, { useState } from "react";
import { Button, useRefresh, useNotify, useUnselectAll } from "react-admin";
import axios from "axios";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";

const BulkReportButton = ({ selectedIds }) => {
  const [loading, setLoading] = useState(false);
  const refresh = useRefresh();
  const notify = useNotify();
  const unselectAll = useUnselectAll();
  const downloadReport = () => {
    setLoading(true);
    const record = selectedIds;

    for (let id in record) {
      setLoading(true);
      axios
        .get(window.BaseURL + `/gse/generapdf/${record[id]}`, {
          responseType: "blob",
          headers: {
            Accept: "application/pdf",
            Authorization: `Bearer ${localStorage.getItem("auth")}`,
          },
        })
        .then((response) => {
          refresh();
          unselectAll();
          setLoading(false);
          const url = URL.createObjectURL(response.data);
          let link = document.createElement("a");
          link.href = url;
          const filename = response.headers["x-suggested-filename"];
          link.download = filename;
          link.click();
        })
        .catch(function (error) {
          setLoading(false);
          alert(`Non è stato possibile scaricare il file.\n${error}`);
          console.log(error);
        });
    }
  };

  return (
    <Button
      label="Genera report"
      disabled={loading}
      onClick={downloadReport}
      icon={PictureAsPdfIcon}
    >
      <PictureAsPdfIcon />
    </Button>
  );
};

export default BulkReportButton;
